import { FAQ } from "components/faq"
import {BaseLayout} from "../../layouts/Base";

export const FAQPage = () => {
    return (
        <BaseLayout>
            <FAQ/>
        </BaseLayout>
    )
}